import { Reveal } from "./Reveal";
import BookingForm from "./BookingForm";

export default function ContactSection() {
  return (
    <section
      id="contact"
      className="py-24 sm:py-32 border-t border-[#27272a] scroll-mt-20 relative overflow-hidden"
      data-testid="section-contact"
    >
      <div
        className="absolute -top-40 right-0 h-[500px] w-[500px] rounded-full blur-[140px] opacity-20"
        style={{ background: "radial-gradient(circle, #ebb323, transparent 70%)" }}
      />
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 relative">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="font-mono text-xs uppercase tracking-[0.2em] text-gold">
                [ Book / Inquire ]
              </span>
              <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold uppercase tracking-tighter leading-[0.9] mt-5">
                Start Your
                <br />
                <span className="text-gold">Submission.</span>
              </h2>
              <p className="text-zinc-400 mt-6 leading-relaxed max-w-md">
                Booking a studio slot, prepping grails, or launching your channel?
                Send us the details and we'll respond fast. Advance booking required.
              </p>
              <div className="mt-10 space-y-4 font-mono text-sm text-zinc-400">
                <p>Next group submission departs 1st &amp; 15th monthly.</p>
                <p className="text-zinc-600">
                  Full contact details published at launch.
                </p>
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-7">
            <Reveal delay={0.15}>
              <BookingForm />
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
